import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppErrors, NotFoundError } from '@fitness-force/errors';
import { StaffNotification } from '@fitness-force/models';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { CONST_URL_SEGEMENTS } from 'libs/constants/src/lib/constants.url';
import { catchError, map, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StaffNotificationService {
  constructor(private http: HttpClient) {}

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  getNotifications(): Observable<StaffNotification> {
    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.STAFF.STAFF_NOTIFICATIONS}`, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  patchNotifications(request: any): Observable<any> {
    return this.http.patch(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.STAFF.STAFF_NOTIFICATIONS}`,request,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getStaffNotifications(): Observable<any> {
    return this.http.get(`${environment.BASE_URL}/staff/notifications`,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markNotificationAsRead(tenantId:number, payload:any ): Observable<any> {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/staff/notifications/mark_as_read`,payload,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markNotificationAsDelete(tenantId:number, id:number): Observable<any> {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/staff/notifications/${id}/mark_as_delete`,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

}
